import type { ReactNode } from 'react';

import { Tooltip, TooltipContent, TooltipTrigger } from '~/components/ui/tooltip';
import { cn } from '~/utils/cn';

interface Props {
  children: ReactNode;
  /** Plain-words definition; omitted → the term renders as plain text with no tooltip. */
  hint?: string | undefined;
  className?: string;
}

/** A term with a dotted underline whose tooltip defines it (stage pane "descriptive" rule) — the
 *  one way the pane explains a label ("Usable", "Destination accepts") without extra copy. */
export function HintTerm({ children, hint, className }: Props) {
  if (!hint) return <span className={className}>{children}</span>;
  return (
    <Tooltip delayDuration={200}>
      <TooltipTrigger asChild>
        <span
          className={cn('cursor-help underline decoration-dotted underline-offset-2', className)}
        >
          {children}
        </span>
      </TooltipTrigger>
      <TooltipContent className="max-w-xs">{hint}</TooltipContent>
    </Tooltip>
  );
}
